import React, {useEffect} from "react";

import {Form, Table} from 'react-bootstrap';
import {Dropdown} from '../../../../../shared/ui/Dropdown';

const ModbusTCPMeterTable = (props) => {

  return (
    <Table>
      <tbody>
      <tr>
        <th className="text-start"><span>Typ</span></th>
        <td className="text-end"><span>{props.device.deviceType}</span></td>
      </tr>
      <tr>
        <th className="text-start"><span>Name</span></th>
        <td className="text-end"><span>{props.device.name}</span></td>
      </tr>
      <tr>
        <th className="text-start"><span>Modbus ID</span></th>
        <td className="text-end"><span>{props.device.modbusId}</span></td>
      </tr>
      <tr>
        <th className="text-start"><span>IP</span></th>
        <td className="text-end"><span>{props.device.ip}</span></td>
      </tr>
      </tbody>
    </Table>
  )
}

const ModbusTCPMeterForm = (props) => {

  // verify all fields are filled before saving
  useEffect(() => {
    if (props.device.name && props.device.modbusId && props.device.ip) {
      props.setSaveDisabled(false);
    } else {
      props.setSaveDisabled(true);
    }
  }, [props.device]);
  return (
    <Form>
      <Form.Group>
        <Form.Label>Typ</Form.Label>
        <Dropdown
          name="deviceType"
          options={[
            {value: 'SiemensPAC2200', label: 'Siemens PAC2200'},
            {value: 'EMUProII', label: 'EMU Professional II'},
            {value: 'JanitzaUMG96', label: 'Janitza UMG96'},
          ]}
          value={props.device.deviceType}
          onChange={props.handleChange}
          placeholder="select..."
          block
        />
      </Form.Group>
      <Form.Group>
        <Form.Label>Name</Form.Label>
        <Form.Control
          type="text"
          name="name"
          value={props.device.name}
          onChange={props.handleChange}/>
      </Form.Group>
      <Form.Group>
        <Form.Label>Modbus ID</Form.Label>
        <Form.Control
          type="number"
          name="modbusId"
          value={props.device.modbusId}
          onChange={props.handleChange}/>
      </Form.Group>
      <Form.Group>
        <Form.Label>IP</Form.Label>
        <Form.Control
          type="text"
          name="ip"
          value={props.device.ip}
          onChange={props.handleChange}/>
      </Form.Group>
    </Form>
  )
}

export {ModbusTCPMeterForm, ModbusTCPMeterTable};